import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { ComplianceTermsFilters } from './filters';
import { ComplianceTermsList } from './list';
import { Param } from '../../../../shared/types/param';
import { COMPLIANCE_TERMS_NEW } from '../../../../routes/paths';
import { isTrainerOrQuality } from '../../../../shared/types/profiles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

export const ComplianceTerms = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [filters, setFilters] = useState<Param>();

    return (
        <>
            <LayoutModule
                title="Búsqueda de Cumplimiento de términos"
                showTitle
                {...(!isTrainerOrQuality(type) && {
                    createPath: COMPLIANCE_TERMS_NEW,
                })}
            >
                <ComplianceTermsFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <ComplianceTermsList filters={filters} />
        </>
    );
};
